// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3JTHu","search":"Settings_search__2Bz7a","filter":"Settings_filter__1j-wJ"};